import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApplicationHostTypeService, ReferenceDataService, ReferenceDataLabels } from 'rome-library';
import { BrowserDetectorService } from './core/services/browser-detector.service';

import { States } from './shared/constants/states';
import { TaggingService } from './tag-manager';

@Component({
  selector: 'boi-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private readonly EXCLUDED_STATES_FOR_UNSUPPORTED_DEVICE_CHECK = [States.DeviceInfo, `/${States.Redirect}`];

  constructor(
    private readonly browserDetectorService: BrowserDetectorService,
    private readonly router: Router,
    private readonly applicationHostTypeService: ApplicationHostTypeService,
    private readonly taggingService: TaggingService,
    private readonly titleService: Title,
    private readonly referenceDataService: ReferenceDataService
  ) {
    this.setPdfWorkerSrc();
    this.titleService.setTitle(this.referenceDataService.getLocalizeLabel(ReferenceDataLabels.PageTitle));
  }

  public ngOnInit(): void {
    this.taggingService.initialize();
    if (!this.isStateExcludedFromUnsupportedDeviceCheck()) {
      this.checkUnsupportedDevice();
    }
  }

  private checkUnsupportedDevice(): void {
    this.browserDetectorService.checkUnsupportedDevice(() => this.goToDeviceNotSupportedPage());
    this.browserDetectorService.checkIfDeviceIsNotAllowedForActualConfiguration(() =>
      this.goToDeviceNotSupportedPage()
    );
  }

  private isStateExcludedFromUnsupportedDeviceCheck(): boolean {
    const currentUrl = window.location.pathname.toLowerCase();
    const isStateExcluded = this.EXCLUDED_STATES_FOR_UNSUPPORTED_DEVICE_CHECK.some(
      (stateName) => currentUrl.indexOf(stateName.toLowerCase()) !== -1
    );

    return isStateExcluded;
  }

  private goToDeviceNotSupportedPage(): void {
    void this.router.navigate(['/', this.applicationHostTypeService.getCode(), States.UnsupportedDevice]);
  }

  private setPdfWorkerSrc(): void {
    (window as any).pdfWorkerSrc = 'assets/pdfjs/pdf.worker.min.js';
  }
}
